import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { NAV_BAR_HEIGHT } from 'HubStyleTokens/sizes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILink from 'UIComponents/link/UILink';
import getLangLocale from 'I18n/utils/getLangLocale';
import { getDashboardRedirectUrl, getDeveloperHomeRedirectUrl, getEnglishBaseUrl, getPublicRootUrl } from '../utils/urls';
import { useAppSelector } from '../reducers';
import { selectIsCRMDevUngated, selectIsPublicDocs } from '../selectors/auth';
import LayoutPublic from './LayoutPublic';
import { Paths } from './RoutesPublic';
import { MAX_WIDTH } from './apiReference/constants';
import { useEffect } from 'react';
import { getUsageTracker } from '../utils/usage-tracker';
import getIsPrerenderUserAgent from 'developer-docs-shared-components/utils/getIsPrerenderUserAgent';
import { LinkWithEnglishSuperset } from 'developer-docs-shared-components/components/Link';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullHeightDiv = styled.div.withConfig({
  displayName: "NotFound__FullHeightDiv",
  componentId: "jexxzc-0"
})(["min-height:calc(100vh - ", ");"], NAV_BAR_HEIGHT);
const NotFound = ({
  overriddenLocale
}) => {
  const isPublicDocs = useAppSelector(selectIsPublicDocs);
  const locale = overriddenLocale || getLangLocale();
  const {
    pathname
  } = useLocation();
  const isEnUs = locale === 'en-us';
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: 'notFound',
      subscreen: 'notFound'
    });
    if (isPublicDocs && getIsPrerenderUserAgent()) {
      // Set Prerender status code meta tag @see https://docs.prerender.io/docs/11-best-practices
      const statusCodeEl = document.createElement('meta');
      statusCodeEl.name = 'prerender-status-code';
      statusCodeEl.content = '404';
      document.head.appendChild(statusCodeEl);
    }
    window.prerenderReady = true;
  }, [isPublicDocs]);
  // If a user is CRM Dev ungated, assume we can redirect to the dev home
  const isCRMDevUngated = useAppSelector(selectIsCRMDevUngated);
  let redirectLink = /*#__PURE__*/_jsx(UILink, {
    href: getDashboardRedirectUrl(),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-docs-ui.gated.dashboard"
    })
  });
  if (isCRMDevUngated) {
    redirectLink = /*#__PURE__*/_jsx(UILink, {
      href: getDeveloperHomeRedirectUrl(),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.notFound.developerHome"
      })
    });
  }
  if (isPublicDocs) {
    redirectLink = /*#__PURE__*/_jsxs(_Fragment, {
      children: [!isEnUs && /*#__PURE__*/_jsx("p", {
        "data-test-id": "non-english-notfound-link",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "developer-docs-ui.notFound.englishVersionDescription_jsx",
          elements: {
            Link: LinkWithEnglishSuperset
          },
          options: {
            href: getEnglishBaseUrl(pathname),
            hrefLang: 'en-us',
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.notFound.englishVersionLinkText"
            })
          }
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(UILink, {
          href: `${getPublicRootUrl()}${Paths.HOME}`,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-ui.notFound.docsHome"
          })
        })
      })]
    });
  }
  const errorNode = /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "404",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-docs-ui.notFound.header"
    }),
    children: redirectLink
  });
  return isPublicDocs ? /*#__PURE__*/_jsx(LayoutPublic, {
    footerWidth: "full",
    maxContentWidth: MAX_WIDTH,
    sideNavComponent: null,
    showFeedbackForm: false,
    children: errorNode
  }) : /*#__PURE__*/_jsx(FullHeightDiv, {
    className: "align-center justify-center",
    children: errorNode
  });
};
export default NotFound;